export default {
  cunfiguration_profiles_title: "Configuration Profile",
  searchInConfigurationProfiles: "Search",
  create_new_configuration_Profile: "Create New Configuration",
  info_box_description:
    "Configuration Profiles allow you to define and deploy device settings such as Wi-Fi, VPN, email, and system preferences, and more, ensuring consistent setup and streamlined management across all devices.",
  create_new_configuration_Profile_subtitle:
    "Create a Configuration to apply different settings and configurations on devices.",
  searchInSecurityProfiles: "Search in Profiles",
  empty_state: {
    title: "You don’t have any profiles yet",
    description: "Create Profile to restrict devices in your company",
    create_button: "Create First Profile",
    video_description: "Watch How Profile Management Works",
  },
  create_custom_configuration_profile: "Create custom Configuration",
  add_description:
    "Use this section to configure <span class='lowercase'>{{name}}</span> on a device.",
  createConfigurationProfiles: "{{categoryName}} added successfully",
  editConfigurationProfiles: "{{categoryName}} edited successfully",
  no_configuration_profiles: "No Configuration",
  assign_configuration_profiles: "Assign Configuration",
  all_configuration_profiles: "All Configuration",
  suggestions: "Suggestions",
  other_configuration: "Categories",
  add_configuration_profile: "Add Configuration",
  create_configuration_profile_restrict_devices:
    "Create Configuration to restrict devices in your company.",
  remove_configuration_profile: "Remove configuration",
  remove_from_configuration_profile: "Remove This Configuration?",
  delete_dialog: {
    groupNumbers: "Autopilot numbers",
    title: "This profile is activated on {{activeCount}} devices.",
    description: "To delete this profile, enter ",
    description_two: " to confirm",
    depDescription:
      "To delete this profile, enter ‘{{depatmentsName}}’ to confirm.",
    profile_assigned_assets: "This profile assigned to",
    restrictions: "Restrictions",
    byod: "BYOD",
    device_number: "Device number",
    delete_success: "Profile removed",
    delete_description: "The profile has been removed successfully.",
    department_name: "Autopilot name",
    delete_profile_warning: "This action cannot be undone.",
    delete_profile_description:
      "Are you sure you want to remove this profile from your library? All setting will be permanently deleted.",
    warning_two:
      "By deleting this profile, all assigned devices will revert to their default state.",
  },
  configuration_detail: {
    title: "{{configurationName}} Detail",
    category: "Category",
    type: "Type",
    behavior: "Behavior",
    device_type: "Device type",
    osSupportAndVersionCompatiblity: "OS Support & Version Compatibility",
    ownership: "Ownership",
    configurationProfile: "Configuration",
    minimum_version: "Minimum version compatibility",
    osSupportAndVersionCompatibility: "OS Support & Version Compatibility",
    requires: "Requires",
    SECURITY: "Security",
    CONFIGURATION: "Configuration",
    operating_system_support: "Operating system support",
    configuration_policy: "Configuration Policy",
    configuration_polices_description: "Configuration Polices Description",
    configuration_behavior: "Configuration Behavior",
    configuration_activation: "Configuration Activation",
    description: "Description",
    securityProfiles: "Security",
  },
  search_empty_state: {
    title: "Couldn’t find your result",
    description: "The profile you searched is not available",
  },
  emmProfilePolicy: {
    tabs: {
      deviceManagement: "Device management",
      security: "Security",
      network: "Network",
      userInterface: "User interface",
      systemBehavior: "System behavior",
      logsAndMonitoring: "Logs and monitoring",
      other: "Other",
    },
    resetSettings: "Reset to default settings",
    deviceManagement: {
      title: "Device management policies",
      description:
        "Define and enforce rules for device usage and security within your organization.",
    },
    security: {
      title: "Security policies",
      description:
        "Establish and enforce guidelines to protect your organization’s data and systems.",
    },

    network: {
      title: "Network policies",
      description: "Set and manage rules to control network access and usage.",
    },
    userInterface: {
      title: "User interface policies",
      description:
        "Define and customize the user interface settings for your organization’s devices.",
    },
    systemBehavior: {
      title: "System behavior policies",
      description:
        "Configure and control how your system operates under various conditions.",
    },
    logsAndMonitoring: {
      title: "Logs and monitoring policies",
      description:
        "Enable detailed tracking and analysis of system activities and performance.",
    },
    other: {
      title: "Other items policies",
      description:
        "Customize and optimize miscellaneous features to suit your organization.",
    },
  },
};
